import React from "react";

import { Drawer } from "@mui/material";
import HeaderMenu from "./HeaderMenu";

const MobileMenu = (props) => {
  const { mobileMenu, toggleMobileMenu } = props;
  return (
    <Drawer
      //   container={container}
      variant="temporary"
      open={mobileMenu}
      onClose={toggleMobileMenu}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      anchor="top"
      //   sx={{ maxWidth: "100vw" }}
      PaperProps={{
        sx: {
          backgroundColor: "secondary.main",
          maxWidth: "100vw",
        },
      }}
      //   sx={{
      //     display: { xs: "block", sm: "none" },
      //     "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
      //   }}
    >
      <HeaderMenu />
    </Drawer>
  );
};

export default MobileMenu;
